import { render, staticRenderFns } from "./adminForms.vue?vue&type=template&id=3246b46c&scoped=true"
import script from "./adminForms.vue?vue&type=script&lang=js"
export * from "./adminForms.vue?vue&type=script&lang=js"
import style0 from "./adminForms.vue?vue&type=style&index=0&id=3246b46c&prod&lang=css"
import style1 from "./adminForms.vue?vue&type=style&index=1&id=3246b46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246b46c",
  null
  
)

export default component.exports